import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export async function deleteDamagePolygon(polygonId: string): Promise<{ success: boolean } | null> {
	// DELETE /api/polygons/:id
	const response = await axios.delete(`${API_URLS.DAMAGE_POLYGONS.INDEX}/${polygonId}`);

	return getResponse<{ success: boolean }>(response.data);
}
